import React, { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Buffer } from "buffer";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { Paginator, PaginatorPageChangeEvent } from "primereact/paginator";
import { Divider } from "primereact/divider";
import {
  obtener_concurso,
  obtener_cantidad_concurso,
  obtener_archivos,
  obtener_tipo_contrato,
  obtener_jornada,
  obtener_unidad,
} from "../../Api/api";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primeflex/primeflex.css";
import { Column } from "primereact/column";
import { PrimeReactProvider } from "primereact/api";
import "./PlataformaConcursos.css";
import { Concurso, informaciones, jornada, tipo_c, unidad } from "../Concurso";
import IconvLite from "iconv-lite";
import { ProgressSpinner } from "primereact/progressspinner";
import { Tag } from "primereact/tag";
import { Chip } from "primereact/chip";
import { InputSwitch } from "primereact/inputswitch";
import { Slider, SliderChangeEvent } from "primereact/slider";

const concur: Concurso = {
  id: 0,
  titulo: "",
  cargo: "",
  fecha_creacion: new Date(Date.now()),
  fecha_termino: new Date(Date.now()),
  inclusion: false,
  sueldo: 0,
  visible: false,
  tipo_c_id: 0,
  jornada_id: 0,
  unidad_id: 0,
  tiene_resultado: false,
  informaciones: [],
  tipo_c: { id: 0, tipo_c: "" },
  jornada: { id: 0, tipo: "" },
  unidad: { id: 0, unidad: "" },
};
const contrat: tipo_c = { id: NaN, tipo_c: "" };

const uni: unidad = { id: NaN, unidad: "" };

const jor: jornada = { id: NaN, tipo: "" };

const Plataforma_Concursos: React.FC = () => {
  const [informaciones, setInformaciones] = useState<informaciones[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [Titulo, setTitulo] = useState<string>("");
  const [cargando, setCargando] = useState<boolean>(false);
  const [cargandoLista, setCargandoLista] = useState<boolean>(false);
  const [showInformacion, setShowInformacion] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentPage2, setCurrentPage2] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(3);
  const [Totalpaginas, setTotalpaginas] = useState<number>(0);
  const [archiv, setArchiv] = useState<number>(1);
  const [Concursos, setConcursos] = useState<Concurso[]>([]);
  //const [unidades, setUnidades] = useState<unidad[]>([]);
  const [contratos, setContratos] = useState<tipo_c[]>([]);
  const [jornadas, setJornadas] = useState<jornada[]>([]);
  //const [unidad_seleccionada, setUnidad_seleccionada] = useState<unidad>(uni);
  const [contrato_seleccionado, setContrato_seleccionado] =
    useState<tipo_c>(contrat);
  const [jornada_seleccionada, setJornada_seleccionada] =
    useState<jornada>(jor);
  const [archivoss, setarchivoss] = useState<Concurso[]>([]);
  const [verHistoricos, setVerHistoricos] = useState<boolean>(false);
  const [soloVigentes, setSoloVigentes] = useState<boolean>(false);
  const [concursoSeleccionado, setConcursoSeleccionado] = useState<Concurso | null>(null);
  const [inclusion, setInclusion] = useState<boolean>(false);
  const [valMax, setValMax] = useState<number>(15000000);
  const [valMin, setValMin] = useState<number>(0);
  const [cargo, setCargo] = useState<string>("");
  const [precio, setPrecio] = useState<number | [number, number]>([0, 0]);
  const [isPressed, setIsPressed] = useState<boolean>(false);
  const isFirstRender = useRef(true);

  useEffect(() => {
    obtenerTiposcontrato();
    obtenerJornadas();
    //obtenerUnidades();
  }, []);

  useEffect(() => {
    obtenerConcurso();
    obtenerCantidad();
  }, [currentPage, itemsPerPage, isPressed]);

  // Debounce: buscar automáticamente 400ms después de dejar de escribir
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const timer = setTimeout(() => {
      setCurrentPage(1);
      setIsPressed((prev) => !prev);
    }, 400);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  const handleSliderChange = (e: SliderChangeEvent) => {
    const [newMin, newMax] = updateSliderValues(
      (e.value as [number, number])[0],
      (e.value as [number, number])[1]
    );
    setValMin(newMin);
    setValMax(newMax);
    setPrecio([newMin, newMax]);
  };

  function updateSliderValues(min: number, max: number): [number, number] {
    if (min > max) {
      return [max, min];
    } else {
      return [min, max];
    }
  }

  function formatNumberWithThousandsSeparator(num: number): string {
    return num.toLocaleString("es-ES", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  const handleClick = () => {
    cerrarDetalle();
    setCurrentPage(1);
    setIsPressed((prev) => !prev);
  };

  const triggerSearch = () => {
    setCurrentPage(1);
    setIsPressed((prev) => !prev);
  };

  const toggleHistoricos = () => {
    cerrarDetalle();
    setCurrentPage(1);
    setVerHistoricos((prev) => {
      const next = !prev;
      return next;
    });
    setIsPressed((prev) => !prev);
  };

  const obtenerConcurso = async () => {
    setCargandoLista(true);
    await obtener_concurso(
      searchTerm,
      currentPage,
      itemsPerPage,
      false,
      contrato_seleccionado,
      jornada_seleccionada,
      //unidad_seleccionada,
      valMax,
      valMin,
      cargo,
      verHistoricos,
      soloVigentes
    )
      .then((data) => {
        console.log(data);
        setConcursos(data);
        setCargandoLista(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setCargandoLista(false);
      });
  };

  const obtenerCantidad = async () => {
    await obtener_cantidad_concurso(
      searchTerm,
      false,
      contrato_seleccionado,
      jornada_seleccionada,
      //unidad_seleccionada,
      valMax,
      valMin,
      cargo,
      verHistoricos,
      soloVigentes
    )
      .then((data) => {
        setTotalpaginas(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const obtenerArchivos = async (arch: number) => {
    setCargando(true);
    await obtener_archivos(arch)
      .then((data) => {
        console.log("Data recibido:", data); // Verifica la estructura completa de los datos
        if (data.length > 0) {
          console.log("Informaciones:", data[0].informaciones); // Intenta acceder a informaciones nuevamente
          setInformaciones((data[0].informaciones || []).slice().sort((a, b) => a.tipo_id - b.tipo_id));
        } else {
          setInformaciones([]);
        }
        setCargando(false);
      })
      .catch((error) => {
        setCargando(false);
        console.error("Error fetching data:", error);
      });
  };

  const obtenerTiposcontrato = async () => {
    await obtener_tipo_contrato()
      .then((data) => {
        setContratos(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const obtenerJornadas = async () => {
    await obtener_jornada()
      .then((data) => {
        setJornadas(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  /**
  const obtenerUnidades = async () => {
    await obtener_unidad()
      .then((data) => {
        setUnidades(data);
      })
      .catch((error) => {
        console.error("Error fektching data:", error);
      });
  };
  */

  const OcultarConcursos = () => {
    setShowInformacion(false);
  };

  const MostrarConcursos = (concurso: Concurso) => async () => {
    await SetValores(concurso);
  };

  const SetValores = async (concurso: Concurso) => {
    setArchiv(concurso.id);
    setTitulo(concurso.titulo);
    setConcursoSeleccionado(concurso);
    setShowInformacion(true);
    setCargando(true);
    await obtenerArchivos(concurso.id);
  };

  const CORREO_CONTACTO = "reclutamiento.seleccion.ddp@uantof.cl";

  const getJornada = (jornada_id: number) =>
    jornadas.find((j) => j.id === jornada_id)?.tipo ?? "-";

  const getContrato = (tipo_c_id: number) =>
    contratos.find((c) => c.id === tipo_c_id)?.tipo_c ?? "-";

  const getEstadoConcurso = (concurso: Concurso): { label: string; severity: "success" | "warning" | "info"; dimmed: boolean } => {
    if (concurso.tiene_resultado) {
      return { label: "Resultado publicado", severity: "info", dimmed: true };
    }
    // Históricos (sin fechas) o con plazo expirado
    if (!concurso.fecha_termino || new Date(concurso.fecha_termino) < new Date()) {
      return { label: "Plazo vencido", severity: "warning", dimmed: true };
    }
    return { label: "Vigente", severity: "success", dimmed: false };
  };

  const formatFecha = (fecha: Date | null | undefined) => {
    if (!fecha) return "-";
    return new Date(fecha).toLocaleDateString("es-CL", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const hola = (base64: Buffer) => {
    const transforms = IconvLite.decode(base64, "utf8");
    const base64String = atob(transforms);
    const arrayBuffer = new ArrayBuffer(transforms.length);
    const view = new Uint8Array(arrayBuffer);
    for (let i = 0; i < base64String.length; i++) {
      view[i] = base64String.charCodeAt(i);
    }
    // Crea un blob con los datos del archivo
    const blob = new Blob([view], { type: "application/pdf" });
    return blob;
  };

  const handleContratoChange = (value: tipo_c) => {
    setContrato_seleccionado(value ?? contrat);
    setCurrentPage(1);
    setIsPressed((prev) => !prev);
  };

  const handleJornadaChange = (value: jornada) => {
    setJornada_seleccionada(value ?? jor);
    setCurrentPage(1);
    setIsPressed((prev) => !prev);
  };

  const handleSoloVigentesChange = (value: boolean) => {
    setSoloVigentes(value);
    setCurrentPage(1);
    setIsPressed((prev) => !prev);
  };

  const hayFiltrosActivos =
    !!searchTerm || !isNaN(contrato_seleccionado.id) || !isNaN(jornada_seleccionada.id) || soloVigentes;

  const handleClean = () => {
    setContrato_seleccionado(contrat);
    setJornada_seleccionada(jor);
    setSoloVigentes(false);
    setSearchTerm("");
    setCargo("");
    setValMin(0);
    setValMax(15000000);
    cerrarDetalle();
    setCurrentPage(1);
    setIsPressed((prev) => !prev);
  };

  const onPageChange = (event: PaginatorPageChangeEvent) => {
    cerrarDetalle();
    setItemsPerPage(event.rows);
    //console.log(event.rows);
    setCurrentPage(Math.ceil(event.first / event.rows) + 1);
    //console.log(event.first);
  };

  const onPageChange2 = (event: { first: number }) => {
    setCurrentPage2(Math.ceil(event.first / 1) + 1);
  };

  const cerrarDetalle = () => {
    setShowInformacion(false);
    setInformaciones([]);
    setArchiv(1);
    setTitulo("");
    setConcursoSeleccionado(null);
    setCargando(false);
    setCurrentPage2(1);
  };

  return (
    <>
      <PrimeReactProvider>
        <style>{`
        .p-datatable-thead {
          display: none  
        }
      `}</style>
        <div className="">
          <div className=" grid mb-2 bg-blue-500">
            <div className="col-12 flex align-items-center justify-content-between">
              <div className="flex align-items-center ml-4" style={{ flex: 1 }}>
                <img
                  alt="logo"
                  src="logo_ua_blanco.png"
                  style={{ maxWidth: "10%" }}
                  className="mr-2"
                />
              </div>
              <div
                className="text-center text-white-alpha-90"
                style={{ fontWeight: "bold" }}
              >
                <span>
                  UNIVERSIDAD DE ANTOFAGASTA <br />
                </span>
                <div
                  className="max-w-16rem custom-divider my-2 mx-auto"
                  style={{
                    borderTop: "2px solid orange",
                    width: "100%",
                    margin: "0 auto",
                  }}
                />
                <span>PORTAL DE CONCURSOS</span>
              </div>
              <div className="flex align-items-center justify-content-end mr-4" style={{ flex: 1 }}>
                <a
                  href="https://www.uantof.cl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-button font-bold bg-orange-400"
                >
                  Volver
                </a>
              </div>
            </div>
          </div>
          {/* Barra unificada de búsqueda y filtros */}
          <div
            className="flex flex-wrap align-items-center gap-3 px-4 py-3"
            style={{ backgroundColor: "#f8f9fa", borderBottom: "1px solid #dee2e6" }}
          >
            {/* Búsqueda */}
            <div className="flex align-items-center">
              <InputText
                placeholder="Buscar concursos"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <Button
                className="checkbox-p bg-orange-400"
                icon="pi pi-search"
                onClick={handleClick}
              />
            </div>

            {/* Filtros (solo en modo normal) */}
            {!verHistoricos && (
              <>
                <div className="flex align-items-center gap-2">
                  <InputSwitch
                    checked={soloVigentes}
                    onChange={(e) => handleSoloVigentesChange(e.value ?? false)}
                  />
                  <label
                    className="font-medium text-sm"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleSoloVigentesChange(!soloVigentes)}
                  >
                    Solo vigentes
                  </label>
                </div>
                <Dropdown
                  value={isNaN(contrato_seleccionado.id) ? null : contrato_seleccionado}
                  onChange={(e) => handleContratoChange(e.value)}
                  options={contratos}
                  optionLabel="tipo_c"
                  placeholder="Tipo de convocatoria"
                  showClear
                  style={{ minWidth: "13rem" }}
                />
                <Dropdown
                  value={isNaN(jornada_seleccionada.id) ? null : jornada_seleccionada}
                  onChange={(e) => handleJornadaChange(e.value)}
                  options={jornadas}
                  optionLabel="tipo"
                  placeholder="Jornada"
                  showClear
                  style={{ minWidth: "11rem" }}
                />
              </>
            )}

            {/* Ver históricos */}
            <Button
              label={verHistoricos ? "Ver concursos activos" : "Ver históricos"}
              icon={verHistoricos ? "pi pi-list" : "pi pi-clock"}
              style={{
                backgroundColor: verHistoricos ? "#1e40af" : "#6b7280",
                border: "none",
                color: "white",
              }}
              onClick={toggleHistoricos}
            />

            {/* Limpiar todo */}
            {hayFiltrosActivos && !verHistoricos && (
              <Button
                label="Limpiar todo"
                icon="pi pi-times"
                severity="secondary"
                text
                size="small"
                onClick={handleClean}
              />
            )}
          </div>
        </div>
        {verHistoricos && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              margin: "0.75rem 1rem 0",
              padding: "0.6rem 1rem",
              backgroundColor: "#dbeafe",
              borderLeft: "4px solid #1e40af",
              borderRadius: "4px",
            }}
          >
            <i className="pi pi-clock" style={{ color: "#1e40af" }} />
            <span style={{ color: "#1e40af", fontWeight: 600, fontSize: "0.9rem" }}>
              Mostrando concursos históricos — ordenados del más reciente al más antiguo
            </span>
          </div>
        )}
        <div className="grid" style={{ padding: "2%" }}>
          <div className={showInformacion ? "col-4" : "col-12"}>

            {/* Chips de filtros activos */}
            {(searchTerm || !isNaN(contrato_seleccionado.id) || !isNaN(jornada_seleccionada.id)) && (
              <div className="flex flex-wrap gap-2 mb-3 align-items-center">
                <span className="text-sm font-semibold text-color-secondary">Filtros:</span>
                {searchTerm && (
                  <Chip
                    label={`Búsqueda: "${searchTerm}"`}
                    removable
                    onRemove={() => { setSearchTerm(""); triggerSearch(); }}
                  />
                )}
                {!isNaN(contrato_seleccionado.id) && (
                  <Chip
                    label={contrato_seleccionado.tipo_c}
                    removable
                    onRemove={() => { setContrato_seleccionado(contrat); triggerSearch(); }}
                  />
                )}
                {!isNaN(jornada_seleccionada.id) && (
                  <Chip
                    label={jornada_seleccionada.tipo}
                    removable
                    onRemove={() => { setJornada_seleccionada(jor); triggerSearch(); }}
                  />
                )}
              </div>
            )}

            {/* Contador de resultados */}
            <div className="text-sm text-color-secondary mb-2">
              {cargandoLista
                ? "Cargando..."
                : `${Totalpaginas} concurso${Totalpaginas !== 1 ? "s" : ""} encontrado${Totalpaginas !== 1 ? "s" : ""}`}
            </div>

            {/* Lista o estado vacío */}
            {cargandoLista ? (
              <div className="flex justify-content-center align-items-center" style={{ height: "12rem" }}>
                <ProgressSpinner />
              </div>
            ) : Concursos.length === 0 ? (
              <div className="text-center py-6">
                <i className="pi pi-search" style={{ fontSize: "2.5rem", color: "#ccc" }} />
                <p className="text-color-secondary mt-3 font-medium">No se encontraron concursos</p>
                <p className="text-color-secondary text-sm">Intenta con otros términos o limpia los filtros</p>
              </div>
            ) : (
              <DataTable value={Concursos}>
                <Column
                  className="w-full p-1"
                  body={(rowData: Concurso) => {
                    const estado = getEstadoConcurso(rowData);
                    const seleccionado = concursoSeleccionado?.id === rowData.id;
                    return (
                      <Button
                        className="m-0 p-0 border-black-alpha-10 bg-transparent w-full h-rem"
                        onClick={MostrarConcursos(rowData)}
                      >
                        <Card
                          className="w-full"
                          style={{
                            opacity: estado.dimmed ? 0.6 : 1,
                            border: seleccionado ? "2px solid #f97316" : "2px solid transparent",
                            transition: "border-color 0.2s",
                          }}
                        >
                          <h5 className="text-base m-0 mb-2">{rowData.titulo}</h5>
                          <Tag
                            value={estado.label}
                            severity={estado.severity}
                            style={{ fontSize: "0.75rem" }}
                          />
                        </Card>
                      </Button>
                    );
                  }}
                />
              </DataTable>
            )}

            <Paginator
              first={(currentPage - 1) * itemsPerPage}
              rows={itemsPerPage}
              totalRecords={Totalpaginas}
              rowsPerPageOptions={[3, 5, 10]}
              onPageChange={onPageChange}
            />
          </div>
          {showInformacion && (
            <div className="col-8 mt-3 flip">
              <Card>
                <div className="flex justify-content-between align-items-start mb-3">
                  <h4 className="text-xl font-bold m-0" style={{ lineHeight: 1.3 }}>
                    {Titulo}
                  </h4>
                  <Button
                    className="bg-orange-400 flex-shrink-0 ml-3"
                    icon="pi pi-times"
                    onClick={OcultarConcursos}
                    style={{ minWidth: "2.2rem" }}
                  />
                </div>

                <Divider className="custom-divider mt-2 mb-3" />

                {concursoSeleccionado && (
                  <div className="grid mb-3" style={{ fontSize: "0.88rem" }}>
                    <div className="col-6">
                      <div className="flex align-items-center gap-2 mb-2">
                        <i className="pi pi-clock text-orange-400" />
                        <span className="font-semibold text-color-secondary">Jornada</span>
                      </div>
                      <span>{getJornada(concursoSeleccionado.jornada_id)}</span>
                    </div>
                    <div className="col-6">
                      <div className="flex align-items-center gap-2 mb-2">
                        <i className="pi pi-file text-orange-400" />
                        <span className="font-semibold text-color-secondary">Tipo de convocatoria</span>
                      </div>
                      <span>{getContrato(concursoSeleccionado.tipo_c_id)}</span>
                    </div>
                    <div className="col-6">
                      <div className="flex align-items-center gap-2 mb-2">
                        <i className="pi pi-calendar text-orange-400" />
                        <span className="font-semibold text-color-secondary">Plazo de postulación</span>
                      </div>
                      <span>Hasta el {formatFecha(concursoSeleccionado.fecha_termino)}</span>
                    </div>
                    <div className="col-6">
                      <div className="flex align-items-center gap-2 mb-2">
                        <i className="pi pi-envelope text-orange-400" />
                        <span className="font-semibold text-color-secondary">Correo de contacto</span>
                      </div>
                      <a href={`mailto:${CORREO_CONTACTO}`} style={{ color: "#1e40af" }}>
                        {CORREO_CONTACTO}
                      </a>
                    </div>
                  </div>
                )}

                <Divider className="custom-divider mb-2" />

                <p className="font-semibold mb-2" style={{ fontSize: "0.88rem" }}>
                  Documentos
                </p>

                {cargando ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "6rem",
                    }}
                  >
                    <ProgressSpinner />
                  </div>
                ) : (
                  <DataTable
                    value={informaciones}
                    paginator
                    first={currentPage2 - 1}
                    rows={1}
                    onPage={onPageChange2}
                  >
                    <Column
                      body={(rowData: informaciones) => (
                        <a
                          href={URL.createObjectURL(
                            hola(rowData.archivo_metadato.archivo.documento)
                          )}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {rowData.titulo}
                        </a>
                      )}
                    />
                  </DataTable>
                )}
                <Divider className="custom-divider" />
              </Card>
            </div>
          )}
        </div>
      </PrimeReactProvider>
    </>
  );
};

export default Plataforma_Concursos;
